import firebaseApp from "./firebase";

export const getAuth = () => {
  return firebaseApp.auth();
};

export const getCurrentUser = () =>
  new Promise((resolve, reject) => {
    firebaseApp.auth().onAuthStateChanged(user => {
      resolve(user);
    });
  });

export const facebookOAuth = () => {
  return new firebaseApp.firebase_.auth.FacebookAuthProvider();
};
